export type OrganizationSaveDisabledReason =
  | 'pristine'
  | 'address'
  | 'contact'
  | 'both'

export function getOrganizationSaveDisabledReason(options: {
  isFormPristine: boolean
  isAddressUpdateEnabled: boolean
  isContactUpdateEnabled: boolean
}): OrganizationSaveDisabledReason {
  const { isFormPristine, isAddressUpdateEnabled, isContactUpdateEnabled } = options

  if (isFormPristine) {
    return 'pristine'
  }
  if (!isAddressUpdateEnabled && !isContactUpdateEnabled) {
    return 'both'
  }
  if (!isAddressUpdateEnabled) {
    return 'address'
  }
  if (!isContactUpdateEnabled) {
    return 'contact'
  }
  return 'pristine'
}
